
import { FC, Fragment, useContext } from 'react';
import { cxChessdata, cxChessengine } from '../../../Chessengine';
import CustomInfo from '../Info/CustomInfo';
import AiLevel from './AiLevel';
import PlayButton from './PlayButton';
import MyButton from './MyButton';

/**
 * Settings section
 */
const gameState: Record<
  Parameters<typeof cxChessengine['Provider']>['0']['value']['playType'],
  string
> = {
  PLAY: '2 Pemain Offline',
  VSAI: 'Kamu vs AI'
};

const Settings: FC = () => {
  const { data } = useContext(cxChessdata);
  const { playType } = useContext(cxChessengine);
  if (data == null) return null;

  return (
    <Fragment>
       <div className="container">
      <div className="text-left">
        <p>
        Giliran:&nbsp;<span className="capitalize">{data.turn}</span>
      </p>
      </div>
      <div className="text-right">
        <p>
        Mode:&nbsp;
        <span>{data.isFinished ? 'Finish' : gameState[playType]}</span>
      </p>
        
      </div>
    </div>
    
      <PlayButton vsAi />
      <PlayButton />
      <AiLevel />
      <MyButton />
      <p>
        Jumlah Langkah:&nbsp;<span>{data.fullMove}</span>
      </p>
      
      <CustomInfo data={data} />
    </Fragment>
  );
};

export default Settings;
